import { UserModel } from './userModel';
import z from 'zod';

export type CustomerPropertiesChangedNotification = z.infer<typeof CustomerPropertiesChangedNotification>;

export const CustomerPropertiesChangedNotification = z.object({
    customerGuid: z.string(),
    customerHash: z.string().nullish(),
    propertyNames: z.string().array(),
    properties: UserModel.default({}),
    requestedBy: z.string().nullish(),
});
